<template>
  <div>
    <v-card class="mx-auto" flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="my-auto">
            <v-list-item class="px-3">
              <v-list-item-avatar color="blue">
                <v-icon dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0 px-1">
                <div class="blue--text">
                  {{ $getDeepObj(initValue, 'ptk.nama') }}
                </div>
                <div class="black--text">
                  <span v-if="$getDeepObj(initValue, 'ptk.no_ukg')">
                    <b>Nomor.UKG: </b> {{ $getDeepObj(initValue, 'ptk.no_ukg') }}
                  </span>
                  <span v-else> <b>Email: </b> {{ $getDeepObj(initValue, 'ptk.email') }} </span>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <base-form-generator :schema="schema.dasar" v-model="form" class="pt-5 px-3" />
        <template v-for="(rekaman, id) of schema.rekaman">
          <v-row :key="id">
            <v-col cols="12" md="10">
              <base-form-generator :schema="[rekaman]" v-model="form.url_rekaman" class="pt-5 px-3" />
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mt-5" flat>
      <v-card-text>
        <template>
          <div v-if="berkasesBukti.length">
            <template v-for="(berkas, id) of berkasesBukti">
              <v-row class="px-3" :key="id">
                <v-col cols="12" sm="12" md="5">
                  <span :class="[`px-0 body-2 info--text`]" style="height: 24px">
                    Judul bukti fisik kegiatan ke-{{ id + 1 }}
                  </span>
                  <div>
                    <v-btn
                      color="secondary"
                      class="white--text mr-2"
                      elevation="0"
                      :href="berkas.url_berkas"
                      target="_blank"
                    >
                      <v-icon left dark>
                        mdi-eye
                      </v-icon>
                      Lihat Berkas
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </template>
          </div>
          <div v-else>
            <v-row class="px-3">
              <v-col cols="12">
                <div>
                  <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px">
                    Bukti fisik dokumen yang relevan
                  </span>
                </div>
                <div>
                  <span class="subtitle-1">Belum ada <strong>bukti fisik dokumen</strong> yang diunggah</span>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mt-5" flat>
      <v-card-text>
        <template>
          <div v-if="berkasesFoto.length">
            <template v-for="(berkas, id) of berkasesFoto">
              <v-row class="px-3" :key="id">
                <v-col cols="12" sm="12" md="5">
                  <span :class="[`px-0 body-2 info--text`]" style="height: 24px">
                    Judul foto dokumentasi kegiatan ke-{{ id + 1 }}
                  </span>
                  <div>
                    <v-btn color="secondary" class="white--text mr-2" elevation="0" :href="berkas.url" target="_blank">
                      <v-icon left dark>
                        mdi-eye
                      </v-icon>
                      Lihat Foto
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </template>
          </div>
          <div v-else>
            <v-row class="px-3">
              <v-col cols="12">
                <div>
                  <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px">
                    Foto dokumentasi kegiatan
                  </span>
                </div>
                <div>
                  <span class="subtitle-1">Belum ada <strong>foto dokumentasi kegiatan</strong> yang diunggah</span>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
export default {
  components: { BaseFormGenerator },
  props: {
    berkases: {
      type: Array,
      default: () => [],
    },
    initValue: {
      type: Object,
      default: null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    isRefreshUpload: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      jenis: '',
      title: '',
      rekamans: 1,
      berkasesBukti: [],
      berkasesFoto: [],
    };
  },
  computed: {
    mPertemuan() {
      return this.$getDeepObj(this.initValue, 'config.pendampingan_ke') || {};
    },

    schema() {
      let rekaman = [];
      for (let i = 0; i < this.rekamans; i++) {
        const tautan = this.$getDeepObj(this.form, `url_rekaman.${i}.url_meeting`) || '';
        rekaman.push({
          type: 'textView',
          label: `Rekaman Video Conference ke-${i + 1}`,
          value: [
            `<a type="button" class="white--text mr-2 v-btn v-btn--has-bg theme--light elevation-0 v-size--default secondary" href="${tautan}" target="_blank">`,
            `<span class="v-btn__content"><i class="v-icon v-icon--left mdi mdi-video theme--dark"></i> Lihat Rekaman </span>`,
            `</a>`,
            `<div class="blue--text mt-1">${this.$durasiWaktu(
              this.$getDeepObj(this.form, `url_rekaman.${i}.durasi`) || ''
            )}</div>`,
          ].join(''),
          grid: { cols: 12 },
        });
      }

      const sekolah = this.$getDeepObj(this.initValue, 'sekolah.sekolah.data') || {};
      const pspDiklatSekolah = this.$getDeepObj(this.initValue, 'sekolah.psp_diklat_sekolah.data') || {};

      return {
        dasar: [
          {
            type: 'textView',
            label: `Jadwal Pertemuan`,
            value: this.$getDeepObj(this.initValue, 'jadwal') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Nama Sekolah`,
            value: this.$getDeepObj(sekolah, 'nama'),
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Jenjang Sekolah`,
            value: this.$getDeepObj(sekolah, 'm_jenjang.data.singkat'),
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Nama Kepala Sekolah`,
            value: this.$getDeepObj(pspDiklatSekolah, 'ptk_kasek.data.nama') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Provinsi`,
            value: this.$getDeepObj(sekolah, 'm_propinsi.data.keterangan') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Kota`,
            value: this.$getDeepObj(sekolah, 'm_kota.data.keterangan') || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Waktu Pelaksanaan`,
            value: this.$localDate(this.$getDeepObj(this.initValue, `formulir.tgl_pelaksanaan`)),
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Topik Coaching`,
            value: this.$getDeepObj(this.initValue, `formulir.topik_coaching`),
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Rencana Tindakan`,
            value: this.$getDeepObj(this.initValue, `formulir.rencana_tindakan`) || '-',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Moda Yang Diterapkan`,
            value: this.$getDeepObj(this.initValue, `formulir.m_lokakarya_moda_psp.data.keterangan`) || '-',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: `Catatan Tambahan`,
            value: this.$getDeepObj(this.initValue, `formulir.catatan_tambahan`) || '-',
            grid: { cols: 12 },
          },
          {
            type: 'textView',
            label: `Jumlah Peserta Yang Hadir`,
            value: this.$getDeepObj(this.initValue, `formulir.jml_hadir`) || '',
            grid: { cols: 12 },
          },
        ],
        rekaman: rekaman,
      };
    },
  },
  methods: {
    reset() {
      this.rekamans = 1;
      this.$set(this, 'form', {});
      this.$set(this.form, 'url_rekaman', []);
    },

    initForm(value) {
      if (!value) return;
      const mPertemuan = this.$getDeepObj(value, 'config.pendampingan_ke') || {};

      this.$set(this.form, 'jadwal', mPertemuan[value.kPertemuan]);

      this.rekamans = (this.$getDeepObj(value, `formulir.url_rekaman`) || []).length;
      this.$set(this.form, 'url_rekaman', []);
      for (let i = 0; i < this.rekamans; i++) {
        this.$set(this.form.url_rekaman, i, this.$getDeepObj(value, `formulir.url_rekaman.${i}`) || '');
      }
    },

    initBerkas(berkases) {
      this.berkasesBukti = berkases.filter((berkas) => berkas.jenis === 'bukti');
      this.berkasesFoto = berkases.filter((berkas) => berkas.jenis === 'foto');
    },
  },
  watch: {
    initValue: 'initForm',
    berkases: 'initBerkas',
  },
};
</script>
